var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-range-picker',{ref:"picker",staticStyle:{"width":"300px"},attrs:{"format":"YYYY-DD-MM","locale-data":{
    applyLabel: _vm.$lang.messages.apply,
    cancelLabel: _vm.$lang.messages.cancel_btn_text,
  },"ranges":{
    [_vm.$lang.messages.today]: [_vm.moment(), _vm.moment()],
    [_vm.$lang.messages.yesterday]: [_vm.moment().subtract(1, 'days'), _vm.moment().subtract(1, 'days')],
    [_vm.$lang.messages.this_month]: [_vm.moment().startOf('month'), _vm.moment().endOf('month')],
    [_vm.$lang.messages.this_year]: [_vm.moment().startOf('year'), _vm.moment().endOf('year')],
    [_vm.$lang.messages.last_week]: [_vm.moment().subtract(1, 'week').startOf('week'), _vm.moment().subtract(1, 'week').endOf('week')],
    [_vm.$lang.messages.last_month]: [_vm.moment().subtract(1, 'month').startOf('month'), _vm.moment().subtract(1, 'month').endOf('month')]
  }},on:{"update":_vm.onUpdate},model:{value:(_vm.currentDate),callback:function ($$v) {_vm.currentDate=$$v},expression:"currentDate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }